import { NgModule } from '@angular/core';
import { RouterModule, Routes, NoPreloading, PreloadAllModules } from '@angular/router';
import { CareerPortalLayoutComponent } from './layouts/career-portal-layout/career-portal-layout.component';

export const appRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'careers'
  },
  {
    path: 'careers', component: CareerPortalLayoutComponent,
    children: [
      { path: '', loadChildren: () => import('./requisition/requisition.module').then(m => m.RequisitionModule) },
      { path: '', loadChildren: () => import('./candidate/candidate.module').then(m => m.CandidateModule) },
      { path: 'auth', loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule) },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, { preloadingStrategy: NoPreloading })
    // { preloadingStrategy: NoPreloading PreloadAllModules}
  ],
  exports: [
    RouterModule]
})
export class AppRoutingModule { }
